import type { AnyAction,Middleware } from 'redux';
import { LOCATION_CHANGE } from 'redux-first-history';

let previousAction: AnyAction | undefined;

/** Ensure there is no duplicate routing action been sent */
const filterDuplicateLocationChangesMiddleware: Middleware = () => (next) => (action: AnyAction) => {
  if (action.type !== LOCATION_CHANGE) {
    next(action);
    return;
  }
  let skip = false;
  if (previousAction && action.type === previousAction.type && action.type === LOCATION_CHANGE) {
    skip = JSON.stringify(previousAction) === JSON.stringify(action);
  }
  previousAction = action;
  if (!skip) { next(action); }
};

export default filterDuplicateLocationChangesMiddleware;
